import { useBoolState } from '@/hooks/state/useBoolState';
/**
 * アコーディオンのアニメーションに必要な値を返す
 * @description details/summary 以外の HTML 要素を使用したアコーディオンのアニメーションを制御する
 */
export const useAccordionNonDetails = (options) => {
    var _a;
    const { contentRef } = options;
    /**
     * アコーディオンの表示状態
     */
    const { boolState: isOpen, changeToggle: toggleIsOpen } = useBoolState();
    /**
     * アコーディオンコンテンツ部分の高さ
     */
    const contentHeight = ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
    return {
        contentHeight,
        isOpen,
        toggleIsOpen,
    };
};
